import { jsx as p } from "react/jsx-runtime";
import { useMemo as h } from "react";
import c from "../InputContainer/index.js";
import g from "../RawInput/index.js";
import { J as x } from "../../common-6t7itp34.js";
import { extractInputContainerProps as I } from "../../utils/inputs.js";
function N(a) {
  const {
    disabled: o,
    inputClassName: s,
    readOnly: e,
    required: i,
    type: m = "text",
    withDiffView: n,
    value: t,
    prevValue: r,
    ...u
  } = a, [f, l] = I(
    u
  ), d = h(
    () => x(t, r, n),
    [t, r, n]
  );
  return /* @__PURE__ */ p(
    c,
    {
      ...f,
      disabled: o,
      readOnly: e,
      required: i,
      highlightMode: d,
      prevValue: r,
      input: /* @__PURE__ */ p(
        g,
        {
          ...l,
          value: t,
          className: s,
          disabled: o,
          readOnly: e,
          required: i,
          type: m
        }
      )
    }
  );
}
export {
  N as default
};
